import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { select, Store } from '@ngrx/store';
import { getAllCountries, getAllCurrencies, ParticleState } from '@shared/store/reducers/particle.reduer';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { FlowChartDataService } from '../../../services/flow-chart-data.service';
import { FieldConditionModel } from "@shared/models/field-definition";
import { SnackBarService } from "@core/services/snack-bar.service";


@Component({
    standalone: false,
    selector: 'particle-add-condition',
  templateUrl: './add-conditon.component.html',
  styleUrls: ['./add-conditon.component.scss']
})
export class AddConditonComponent implements OnInit, IDialogView, OnDestroy, AfterViewInit {
  data: DialogModel;
  unsubscribe$ = new Subject<void>();
  allCountries: any[];
  allCurrencies: any[];
  answerDropDown: any[];
  selectedSingleAnswer: any;
  booleanArray: any[] = [{ id: 'Yes', text: 'Yes' }, { id: 'No', text: 'No' }];
  selectedMultipleAnswer: any = [];
  dataTypesConfig$: Observable<any>;
  dataTypeConfig: any;
  applicableOperators: any;
  selectedOperator: any;
  candidateSections: any[];
  questions: any[];
  arguments: any;
  fieldLogicGates: any[] = [];
  fieldDefination: any;
  formCondition: any;
  operators: any[] = [];
  isLoadedSavedData = false;
  isAllAlwaysHidden = false;


  constructor(private particleStore: Store<ParticleState>, private queryState: Store<IQueryState>, private flowChartDataService: FlowChartDataService, private snackbarService: SnackBarService) {
    this.selectedOperator = {
      valueSelectionType: 0
    };
    this.arguments = {
      'ApplicationId': 'DataSurvey',
      'IsRelativeTo': false,
      'ForceConditionEditor': false
    };
  }


  async ngOnInit() {
    this.isAllAlwaysHidden = this.data?.input?.isAllAlwaysHidden || false;

    await this.flowChartDataService.getUniqueFlatQuestionsByFlowchartId().then(res => {
      this.questions = res;
    }, err => {
      console.error('getUniqueFlatQuestionsByFlowchartId failed' + err);
    });

    this.dataTypesConfig$ = this.queryState.pipe(select(getQueryResponse, 'FlowchartDataTypes'));
    this.dataTypesConfig$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state) {
        this.dataTypeConfig = state;
        console.log('DataTypes', this.dataTypeConfig);
        this.setDefaultEditors(0);
      }
    });
    QueryProvider.invokeQuery(this.queryState, 'FlowchartDataTypes', { '[FlowChartId]': this.flowChartDataService.flowchartId });

    this.particleStore.pipe(select(getAllCountries)).pipe(takeUntil(this.unsubscribe$)).subscribe(countries => {
      this.allCountries = countries.map(({ code, name, region }) => ({ id: code, text: name, region: region }));
      this.setDefaultEditors(0);
    });
    this.particleStore.pipe(select(getAllCurrencies)).pipe(takeUntil(this.unsubscribe$)).subscribe(currencies => {
      this.allCurrencies = currencies.map(({ currencyCode, displayName }) => ({ id: currencyCode, text: displayName }));
      this.setDefaultEditors(0);
    });

  }

  private setDefaultEditors(index?: any) {
    if (!this.dataTypeConfig || !this.allCountries || !this.allCurrencies) {
      return;
    }
    if (this.data.input.visibilityLogicGate && this.data.input.visibilityLogicGate.fieldLogicGates && this.data.input.visibilityLogicGate.fieldLogicGates.length > 0 && !this.isLoadedSavedData) {
      this.loadSavedConditions();
    }
    if (this.data.input.defaultSelectedQuestion) {
      this.onSelectedQuestionChange(null, index);
    }
  }

  loadSavedConditions() {
    this.isLoadedSavedData = true;
    this.data.input.visibilityLogicGate.fieldLogicGates.forEach((fieldLogicGate, index) => {
      let question = this.questions.find((x) => x.fieldKey === fieldLogicGate.fieldKey);
      if (!question) {
        question = this.questions[0];
      }
      this.setFieldDefination(question);
      const fieldCondition = this.formCondition;
      const applicableOperators = this.getApplicableOperators(question.dataType);
      const lgate = {
        defaultSelectedQuestion: question,
        selectedOperator: {
          valueSelectionType: fieldLogicGate.operator
        },
        selectedSingleAnswer: {},
        selectedMultipleAnswer: [],
        applicableOperators: [],
        answerDropDown: fieldLogicGate.fieldValues,
        nextCondition: fieldLogicGate.nextCondition,
        fieldDefination: this.fieldDefination,
        formCondition: this.formCondition,
        isMultiCheck: fieldLogicGate.operator === 2 || fieldLogicGate.operator === 12,
        isBetween: fieldLogicGate.operator === 5
      };
      fieldCondition.operatorFormControl.setValue(fieldLogicGate.operator);
      // fieldCondition.composedByFormControl.setValue(this.formCondition.composeConditionBy);
      if (fieldLogicGate.operator === 2 || fieldLogicGate.operator === 12 || fieldLogicGate.operator === 16) {
        fieldCondition.valueFormControl.setValue(fieldLogicGate.fieldValues);
        fieldCondition.fieldCondition.operator = fieldLogicGate.operator;
      } else {
        fieldCondition.valueFormControl.setValue(fieldLogicGate.fieldValues[0]);
        fieldCondition.fieldCondition.operator = fieldLogicGate.operator;
      }

      if (fieldLogicGate.operator === 5 && fieldLogicGate.fieldValues.length >= 2) {
        fieldCondition.toValueFormControl.setValue(fieldLogicGate.fieldValues[1]);
      }
      this.arguments = { ...this.arguments, 'IsRelativeTo': fieldLogicGate.operator === 16 };
      lgate['arguments'] = this.arguments;
      lgate['formCondition'] = fieldCondition;
      this.fieldLogicGates.push(lgate);
      this.setDefaultEditors(index);
      this.setOperators(index);
    });
  }

  getApplicableOperators(dataType: string): any {
    const dataTypeConfig = this.dataTypeConfig.dataTypes[dataType];
    const applicableOperators = [];
    dataTypeConfig.operators.forEach(op => {
      const applicableOperator = this.dataTypeConfig.operators.find(o => o.operator === op);
      if (applicableOperator) {
        applicableOperators.push(applicableOperator);
      }
    });
    return applicableOperators;
  }

  setFieldDefination(fieldDefination: any) {
    this.fieldDefination = fieldDefination;
    const isForcedConditionEditor = this.fieldDefination.configKey === 'Dac6-FieldValues-Config' ? true : false;
    this.arguments = { ...this.arguments, 'ForceConditionEditor': isForcedConditionEditor, 'FlowChartId': this.flowChartDataService.flowchartId }; // To avoid Condition Component load by Dac6-FieldValues-Config
    const operatorsId = this.dataTypeConfig.dataTypes[this.fieldDefination['dataType']]?.operators;
    this.operators = [];
    operatorsId.forEach(o => {
      const operator = this.dataTypeConfig['operators'].find(op => op.operator === o);
      this.operators.push({
        displayText: operator.displayText,
        operator: operator.operator
      });
    });
    this.fieldDefination['operators'] = this.operators;
    this.formCondition = FieldConditionModel.create(this.fieldDefination);
  }

  private setOperators(index?: number) {
    const dataType = this.dataTypeConfig.dataTypes[this.fieldLogicGates[index].defaultSelectedQuestion.dataType];
    if (dataType) {
      this.fieldLogicGates[index].applicableOperators = [];
      dataType.operators.forEach(op => {
        const applicableOperator = this.dataTypeConfig.operators.find(o => o.operator === op);
        if (applicableOperator) {
          this.fieldLogicGates[index].applicableOperators.push(applicableOperator);
        }
      });
      this.fieldLogicGates[index].selectedOperator = this.fieldLogicGates[index].applicableOperators.find(o => o.operator === dataType.default);
    } else {
      this.fieldLogicGates[index].applicableOperators = [{ 'displayText': 'Is Answered', operator: 13, valueSelectionType: 0 }];
      this.fieldLogicGates[index].selectedOperator = this.fieldLogicGates[index].applicableOperators[0];
    }
    if (this.fieldLogicGates && this.fieldLogicGates[index]) {
      if (this.data.input.visibilityLogicGate && this.data.input.visibilityLogicGate.fieldLogicGates.length > 0 && this.data.input.visibilityLogicGate.fieldLogicGates[index].operator) {
        this.fieldLogicGates[index].selectedOperator = this.dataTypeConfig.operators.find(o => o.operator === this.data.input.visibilityLogicGate.fieldLogicGates[index].operator);
      } else {
        this.fieldLogicGates[index].selectedOperator = this.dataTypeConfig.operators[0];
      }
      switch (this.fieldLogicGates[index].selectedOperator.valueSelectionType) {
        case 0:
          break;
        case 1:
          if (this.fieldLogicGates[index].fieldValues && this.fieldLogicGates[index].fieldValues.length === 1) {
            this.fieldLogicGates[index].selectedSingleAnswer = this.fieldLogicGates[index].answerDropDown.find((x: any) => x.id === this.fieldLogicGates[index].fieldValues[0]);
          }
          break;
        case 2:
          this.setMultipleSavedValue(index);
          break;
      }
    }
  }

  private setMultipleSavedValue(index?: number) {
    if (this.data.input.visibilityLogicGate.fieldLogicGates[0].fieldValues && this.data.input.visibilityLogicGate.fieldLogicGates[0].fieldValues.length > 0) {
      const fvalues = this.data.input.visibilityLogicGate.fieldLogicGates[0].fieldValues;
      this.selectedMultipleAnswer = (this.answerDropDown.filter((x: any) => {
        for (let i = 0; i < fvalues.length; i++) {
          if (x.id === fvalues[i]) {
            return true;
          }
        }
        return false;
      }));
    }
  }

  ngAfterViewInit(): void {

  }

  onDefaultSelectedOperatorChange(e: any, index?: any) {
    console.log(e);
    const operatorModel = this.dataTypeConfig['operators'].find(op => op.operator === e['value'].operator);
    const operator = {
      displayText: operatorModel.displayText,
      operator: operatorModel.operator
    };
    this.fieldLogicGates[index].fieldDefination['operators'][0] = operator;
    this.fieldLogicGates[index].isMultiCheck = operatorModel.operator === 2 || operatorModel.operator === 12;
    this.fieldLogicGates[index].isBetween = operatorModel.operator === 5;
    this.arguments = { ...this.arguments, 'IsRelativeTo': operatorModel.operator === 16 };
    this.fieldLogicGates[index].arguments = this.arguments;
  }

  onSelectedQuestionChange(e: any, index?: any) {
    if (this.fieldLogicGates.length === 0 || !this.fieldLogicGates[index].defaultSelectedQuestion) {
      this.addFieldLogicGate();
      this.setOperators(index);
      return;
    }
    if (e && e['value']) {
      this.setFieldDefination(e['value']);
      this.fieldLogicGates[index].fieldDefination = this.fieldDefination;
      this.fieldLogicGates[index].selectedOperator = {
        valueSelectionType: 0,
        operator: 0
      };
      const operator = {
        displayText: 'Equals',
        operator: 0
      };
      this.fieldLogicGates[index].formCondition = this.formCondition;
      this.fieldLogicGates[index].fieldDefination['operators'][0] = operator;
      this.fieldLogicGates[index].isMultiCheck = operator.operator === 2 || operator.operator === 12;
      this.fieldLogicGates[index].isBetween = operator.operator === 5;
      this.arguments = { ...this.arguments, 'IsRelativeTo': operator.operator === 16 };
      this.fieldLogicGates[index].arguments = this.arguments;
    }
    this.setAnswerDropdown(index);
    this.setOperators(index);
  }

  onSelectedAnswerChange(e) {

  }

  setAnswerDropdown(index?: number) {
    switch (this.fieldLogicGates[index].defaultSelectedQuestion.dataType.toLowerCase()) {
      case 'list':
      case 'multiplechoice':
      case 'checkbox':
      case 'dropdown':
        this.fieldLogicGates[index].answerDropDown = [].concat(this.fieldLogicGates[index].defaultSelectedQuestion.options);
        break;
      case 'countrycodes':
      case 'countrycode':
        if (this.fieldLogicGates[index].defaultSelectedQuestion.fieldKey === 'EUCountries'
          || this.fieldLogicGates[index].defaultSelectedQuestion.fieldKey === 'IntermediaryInEU'
          || this.fieldLogicGates[index].defaultSelectedQuestion.title === 'EU Countries'
        ) {
          this.fieldLogicGates[index].answerDropDown = [].concat(this.allCountries.filter(x => x.region === 'European Union'));
        } else if (this.fieldLogicGates[index].defaultSelectedQuestion.fieldKey === 'OTHERCountries'
          || this.fieldLogicGates[index].defaultSelectedQuestion.title === 'Other Countries'
        ) {
          this.fieldLogicGates[index].answerDropDown = [].concat(this.allCountries.filter(x => x.region !== 'European Union'));
        } else {
          this.fieldLogicGates[index].answerDropDown = [].concat(this.allCountries);
        }
        break;
      case 'boolean':
        this.fieldLogicGates[index].answerDropDown = [].concat(this.booleanArray);
        break;
      case 'currencycode':
        this.fieldLogicGates[index].answerDropDown = [].concat(this.allCurrencies);
        break;
    }
  }

  ngOnDestroy(): void {
    this.flowChartDataService.destroy();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  clearAnswer() {

  }

  getFieldValues(index?: number) {
    const fc = this.fieldLogicGates[index].formCondition;
    fc.valueFormControl.markAsTouched();
    fc.toValueFormControl.markAsTouched();
    fc.fieldFormControl.markAsTouched();
    fc.operatorFormControl.markAsTouched();
    fc.composedByFormControl.markAsTouched();
    const operator = this.fieldLogicGates[index].selectedOperator.operator;
    let value = fc.valueFormControl.value;
    if (operator === 5) {
      value = [fc.valueFormControl.value, fc.toValueFormControl.value];
    }
    if (Array.isArray(value) === false) {
      value = [value];
    }
    if (operator === 16) {
      value = [fc.valueFormControl.value['selectedDay'], fc.valueFormControl.value['daysType'], fc.valueFormControl.value['decisionType']];
    }
    return value;
  }

  onOkClicked(): boolean {
    this.data.input.visibilityLogicGate.fieldLogicGates = [];
    this.fieldLogicGates.forEach((fieldLogicGate, index) => {
      this.data.input.visibilityLogicGate.fieldLogicGates.push({
        fieldKey: fieldLogicGate.defaultSelectedQuestion.fieldKey,
        dataType: fieldLogicGate.defaultSelectedQuestion.dataType,
        fieldValues: this.getFieldValues(index),
        operator: fieldLogicGate.selectedOperator.operator,
        nextCondition: fieldLogicGate.nextCondition
      });
    });
    this.data.input.visibilityLogicGate.toolTip = this.prepareToolTip();
    return true;
  }

  prepareToolTip() {
    let ending = '';
    let toolTip = '';
    let fieldValues = this.getFieldValues(0);
    if (this.data.input.visibilityLogicGate.visibilityType === 'Conditional') {
      ending = fieldValues[0];
      if (this.fieldLogicGates[0].isMultiCheck) {
        ending += ` (+${fieldValues.length - 1} others)`;
      }
      /*switch (this.fieldLogicGates[0].isMultiCheck) {
        case 0:
          break;
        case 1:
          ending = this.selectedSingleAnswer.text;
          break;
        case 2:
          ending = this.selectedMultipleAnswer[0].text;
          if (this.selectedMultipleAnswer.length === 2) {
            ending += ` (+1 other)`;
          } else if (this.selectedMultipleAnswer.length > 2) {
            ending += ` (+${this.selectedMultipleAnswer.length - 1} others)`;
          }
      }*/
      const question = this.questions.find(x => x.fieldKey === this.fieldLogicGates[0].fieldDefination.fieldKey);
      toolTip = `When ${question.questionId}. ${question.title} ${this.fieldLogicGates[0].selectedOperator.displayText} ${ending}`;
    }
    return toolTip;
  }

  addFieldLogicGate() {
    if (this.questions.length > 0) {
      this.setFieldDefination(this.data.input.defaultSelectedQuestion.item);
      let question = this.questions.find((x) => x.fieldKey === this.data.input.defaultSelectedQuestion.item.fieldKey);
      if (!question) {
        question = this.questions[0];
      }
      const lgate = {
        defaultSelectedQuestion: question,
        selectedOperator: {
          valueSelectionType: 0,
          operator: 0
        },
        selectedSingleAnswer: {},
        selectedMultipleAnswer: [],
        applicableOperators: [],
        answerDropDown: [],
        nextCondition: 1,
        fieldDefination: this.fieldDefination,
        formCondition: this.formCondition,
        isMultiCheck: false,
        isBetween: false
      };
      const fieldCondition = this.formCondition;
      fieldCondition.fieldCondition.operator = 0;
      fieldCondition.valueFormControl.setValue(this.data.input.visibilityLogicGate.fieldValues);
      this.arguments = { ...this.arguments, 'IsRelativeTo': false }
      lgate['arguments'] = this.arguments;
      //lgate['formCondition'] = fieldCondition;
      this.fieldLogicGates.push(lgate);
      //this.setOperators(0);
      this.setDefaultEditors(this.fieldLogicGates.length - 1);
    } else {
      this.snackbarService.showError('Please complete the questionnaire and try again');
    }
  }

}
